import React from "react";
import { Heart, ExternalLink } from "lucide-react";
import { Logo } from "./Logo";

export const Header = ({ info }) => {
  return (
    <header
      className="relative z-10 px-6 sm:px-10 lg:px-14 py-5 flex items-center justify-between border-b border-[var(--mt-line)] backdrop-blur-md bg-[rgba(12,10,8,0.55)]"
      data-testid="site-header"
    >
      <a
        href={info?.website_url || "https://www.radiomadreterra.it"}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-3 group mt-btn"
        data-testid="brand-link"
      >
        <Logo size={42} />
        <div className="leading-tight">
          <div
            className="font-display text-xl sm:text-2xl tracking-tight"
            style={{ color: "var(--mt-cream)" }}
          >
            MADRETERRA <span style={{ color: "var(--mt-amber)" }}>radio</span>
          </div>
          <div
            className="text-[11px] sm:text-xs uppercase tracking-[0.22em]"
            style={{ color: "var(--mt-text-muted)" }}
          >
            in diretta · 24/7
          </div>
        </div>
      </a>

      <nav className="flex items-center gap-2 sm:gap-3">
      </nav>
    </header>
  );
};

export default Header;
